// const logo = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/logo.png';
// const heroImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/heroLarge.png';
// const heroImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/heroSmall.png';
// const heroImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/heroXSmall.png';
// const exploreImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/exploreLarge.png';
// const exploreImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/exploreSmall.png';
// const exploreImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/exploreXSmall.png';
import { themePrimaryColorsBrand } from '../style-constants';

export default {
  extendedTheme: () => ({
    logo: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/logo.png'),
    logoStyle: { height: 125, maxHeight: 125 },
    heroImageLarge: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/heroLarge.png'),
    exploreImageLarge: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/sheraton/exploreLarge.png'),
    palette: {
      primary: {
        main: themePrimaryColorsBrand.SI,
      },
      secondary: {
        main: '#3a3a3a',
      },
      primaryBtnHover: {
        main: '#C5AA90',
      },
      buttonText: {
        main: '#1c1c1c',
      },
      interaction: {
        main: '#8766a9',
      },
      text: {
        primary: '#1c1c1c',
      },
      link: {
        primary: '#1c1c1c',
      },
    },
    typography: {
      useNextVariants: true,
      fontFamily: [
        '"ProximaNova-Regular"',
        '"Roboto"',
        '"Helvetica"',
        '"Arial"',
        'sans-serif',
      ].join(','),
    },
  }),
  typography: (theme, remCalc) => {
    return {
      h1: {
        fontFamily: 'GT-Super-Display-Light',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(54),
          lineHeight: 1.11,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(34),
          lineHeight: 1.24,
        },
      },
      h2: {
        fontFamily: 'GT-Super-Display-Light',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(40),
          lineHeight: 1.15,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(30),
          lineHeight: 1.2,
        },
      },
    };
  },
  extraTypography: (theme, remCalc) => {
    return {
      hero: {
        fontFamily: 'GT-Super-Display-Light',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
      },
      card: {
        fontFamily: 'GT-Super-Display-Light',
        fontWeight: 'bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(38),
          lineHeight: 1.16,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(28),
          lineHeight: 1.21,
        },
      },
    };
  },
};
